module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "fullscreen_11",
    style: (_vm.loading ? '' : 'display:none'),
    attrs: {
      "element-loading-text": "自动登录中，请稍后...",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.8)"
    }
  }), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "systemLogo"
  }, [_c('img', {
    staticClass: "logoImg",
    attrs: {
      "src": _vm.logoSrc,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "logoText"
  }, [_vm._v("远程教学系统")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('div', {
    staticClass: "header-logo"
  }, [_c('i', {
    staticClass: "router-btn",
    on: {
      "click": _vm._backOff
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('i', {
    staticStyle: {
      "font-size": "25px",
      "color": "#bfbfbf",
      "height": "50px",
      "padding": "1px",
      "cursor": "pointer",
      "background": "none",
      "outline": "none"
    },
    on: {
      "click": _vm._forWard
    }
  }, [_vm._v(">")])]), _vm._v(" "), _c('div', {
    staticClass: "header-center"
  })])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('el-dropdown', {
    staticClass: "user-dropdown"
  }, [_c('span', {
    staticClass: "user-avatar"
  }, [_c('span', {
    staticClass: "avatar"
  }, [_c('img', {
    staticClass: "avatar-img",
    attrs: {
      "src": _vm.avatar,
      "alt": ""
    },
    on: {
      "error": _vm.changeToDefaultImg
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "user-name coloc-text"
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('span', {
    staticClass: "user-down"
  }, [_c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })])]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "user-dropmenu",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    staticClass: "logOut menu",
    staticStyle: {
      "clear": "both",
      "min-width": "32%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("退出")]), _vm._v(" "), _c('el-dropdown-item', {
    staticClass: "help menu",
    staticStyle: {
      "clear": "both",
      "min-width": "32%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.help($event)
      }
    }
  }, [_vm._v("帮助")]), _vm._v(" "), _c('el-dropdown-item', {
    staticClass: "about menu",
    staticStyle: {
      "clear": "both",
      "min-width": "32%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.about($event)
      }
    }
  }, [_vm._v("关于")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "parTxt"
  }, [_c('a', {
    staticClass: "unpload",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.upload
    }
  }, [_c('span', {
    staticClass: "el-icon-download"
  }), _vm._v("视频客户端下载\n        ")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-06369f2a","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/header/header.vue
// module id = 519
// module chunks = 1 2 3 4 5 6 7 8